<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>离职管理</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="6">
          <el-input size="small" clearable v-model="searchName" placeholder="请输入姓名或部门">
            <el-button slot="append" icon="el-icon-search" @click="SearchByName"></el-button>
          </el-input>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
        </el-col>
        <!-- <el-col :span="18">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
            style="float:right"
          ></el-pagination>
        </el-col> -->
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="userAllInfo" ref="multipleTable" style="width: 100%" v-loading="loading" size="small">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="sysUser.UserCode" label="工号"></el-table-column>
            <el-table-column prop="sysUser.TrueName" label="姓名"></el-table-column>
            <el-table-column label="部门">
              <template slot-scope="scope">
                <div>
                  <el-popover trigger="hover" placement="top">
                    <el-steps :space="200" :active="1" finish-status="success">
                      {{ scope.row.sysUser.FullPath }}
                    </el-steps>
                    <div slot="reference" class="name-wrapper">
                      <span>{{ scope.row.sysUser.MainDeptsName }}</span>
                    </div>
                  </el-popover>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="UserLeaveInfo.LeaveDate" label="离职日期"></el-table-column>
            <el-table-column prop="UserLeaveInfo.LeaveMainReason" label="离职一级原因"></el-table-column>
            <el-table-column prop="UserLeaveInfo.LeaveReason" label="离职二级原因"></el-table-column>
            <el-table-column prop="UserLeaveInfo.LeaveDeepReason" label="离职深层原因"></el-table-column>
            <el-table-column prop="UserLeaveInfo.LeaveSuggest" label="离职建议"></el-table-column>
            <el-table-column prop="UserLeaveInfo.EntryAgain" :formatter="entryAgain" label="是否再次入职"></el-table-column>
            <el-table-column prop="UserLeaveInfo.IsFollow" :formatter="isFollow" label="是否跟进"></el-table-column>
            <el-table-column prop="UserLeaveInfo.IsuranceEndDate" label="保险停止日期"></el-table-column>
            <el-table-column prop="UserLeaveInfo.Note" label="备注"></el-table-column>
            <el-table-column label="操作" width="100" fixed="right" :span="12">
              <template slot-scope="scope">
                <el-popover placement="right" width="1400" trigger="click">
                  <el-table :data="gridLogData" style="width: 100%">
                    <el-table-column type="expand">
                      <template slot-scope="props">
                        <el-table :data="props.row.Zeus_LogDetails">
                          <el-table-column width="200" property="Name" label="标题"></el-table-column>
                          <el-table-column width="250" property="OldValue" label="旧值"></el-table-column>
                          <el-table-column width="200" property="NewValue" label="新值"></el-table-column>
                        </el-table>
                      </template>
                    </el-table-column>
                    <el-table-column label="记录标题" prop="LogTitle">
                    </el-table-column>
                    <el-table-column label="操作人" prop="OperatorName">
                    </el-table-column>
                    <el-table-column label="操作类型" prop="OperateType">
                    </el-table-column>
                    <el-table-column label="记录类型" prop="LogType">
                    </el-table-column>
                    <el-table-column label="操作IP" prop="OperatorIP">
                    </el-table-column>
                    <el-table-column label="日志时间" prop="LogTime">
                    </el-table-column>
                  </el-table>
                  <el-button type="text" slot="reference" @click="GetLogList(scope.row)"> 人员异动 </el-button>
                </el-popover>
                <el-dropdown @command="(command) => { handleCommand(command, scope.$index, scope.row); }">
                  <span class="el-dropdown-link">
                    更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item class="el-dropdown-link" command="v">查看</el-dropdown-item>
                    <el-dropdown-item class="el-dropdown-link" command="d">清除电话</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-col :span="24">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
          :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount" style="float:right"></el-pagination>
      </el-col>
    </el-card>
  </div>
</template>



<script>
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";
import { GetLogList, GetRemoveSysUserPageList, ClearPhone } from "../../until/ZeusApiSDK/Logic/SysUserLogic";
import { GetCurrentUserInfo } from "../../until/ZeusApiSDK/Logic/HomeLogic";
export default {
  data() {
    return {
      gridLogData: [],
      currentUser: {},//当前用户
      currentRole: {},//当前用户角色
      userAllInfo: [],//数据信息
      searchName: '',//搜索信息
      name: '',//
      pageSizes: [10, 20, 50, 100, 200],
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      loading: true
    };
  },
  created() {
    //获取当前用户信息
    this.getCurrentUser();
    //获取当前用户角色
    this.getCurrentRole();
    //获取当前离职状态列表
    this.GetRemoveSysUserPageList();
  },
  methods: {
    //获取人员异动数据
    GetLogList: function (data) {
      GetLogList(data.sysUser.Id).then(res => {
        this.gridLogData = res.data;
      });
    },
    //获取当前用户
    getCurrentUser: function () {
      var userinfo = window.sessionStorage.getItem("userinfo");
      userinfo = JSON.parse(Decrypt(userinfo));
      this.currentUser = userinfo;
    },
    //获取当前用户角色
    getCurrentRole: function () {
      var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
      this.currentRole = JSON.parse(Decrypt(currentUserRole));
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetRemoveSysUserPageList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetRemoveSysUserPageList();
    },
    SearchByName: function () {
      this.pageIndex = 1;
      this.GetRemoveSysUserPageList();
    },
    Refresh: function () {
      this.GetRemoveSysUserPageList();
    },
    GetRemoveSysUserPageList: function () {
      this.loading = true;
      var userinfo = GetCurrentUserInfo();
      GetRemoveSysUserPageList(
        this.currentUser.UserId,
        this.currentRole.Key,
        this.currentUser.FrameId,
        this.currentRole.OtherFrameID,
        this.searchName == '' ? null : this.searchName,
        this.currentRole.DataAuth,
        this.pageIndex,
        this.pageSize,
      ).then(res => {
        this.loading = false;
        this.userAllInfo = res.List;
        this.totalCount = res.TotalCount;
      });
    },
    //档案状态
    fileStatus(row, column, cellValue, index) {
      if (cellValue == 1) {
        return "已补全";
      } else if (cellValue == 0) {
        return "待完善";
      } else if (cellValue == 2) {
        return "驳回修改";
      }
    },
    //是否再次入职
    entryAgain(row, column, cellValue, index) {
      if (cellValue == 1) {
        return "是";
      } else {
        return "否";
      }
    },
    //是否跟进
    isFollow(row, column, cellValue, index) {
      if (cellValue == 1) {
        return "是";
      } else {
        return "否";
      }
    },
    //审核状态
    status(row, column, cellValue, index) {
      if (cellValue == 6) {
        return "已提交";
      } else if (cellValue == -2) {
        return "初审驳回";
      } else if (cellValue == -3) {
        return "二审驳回";
      } else if (cellValue == 5) {
        return "初审通过";
      } else if (cellValue == 0) {
        if (row.sysUser.FileStatus == "1") {
          return "已补全";
        }
        else {
          return "待完善";
        }
      }
    },
    //查看用户信息
    bindUserInfo: function (data) {
    },

    //删除用户
    delUserInfo: function () {

    },
    //审核通过
    entryUserCompleteSingle: function () {

    },
    //审核驳回
    backFile: function () {

    },

    //入职资料批量通过
    entryUserComplete: function () {

    },
    //删除人员
    DeleteUser: function () {
    },
    handleCommand(command, index, row) {
      if (command == "v") {
        this.$router.push('/SysUser/UserInfo?UserID=' + row.sysUser.Id + '&name=离职管理');
      }
      if (command == "d") {
        if (row.sysUser.Phone != null && row.sysUser.Phone != "") {
          this.$confirm('此操作将删除手机号, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            ClearPhone(row.sysUser.Id, this.currentUser.UserId).then(res => {
              if (res) {
                this.GetRemoveSysUserPageList();
                this.$message({
                  message: '手机号清除成功',
                  type: 'success'
                });
              } else {
                this.$message({
                  message: '手机号清除失败',
                  type: 'warning'
                });
              }
            });
          }).catch(() => { });
        }
        else {
          this.$message({
            message: '员工手机号已清除',
            type: 'warning'
          });
        }
      }
    }
  }
};
</script>
<style>
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF !important;
}
</style>